var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.96 24.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#191e70;}.cls-2,.cls-3{fill-rule:evenodd;}.cls-3{fill:#f7b600;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_364834240",
    "data-name": 364834240
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.85,0H37.11A3.86,3.86,0,0,1,41,3.85V20.6a3.86,3.86,0,0,1-3.85,3.85H3.85A3.86,3.86,0,0,1,0,20.6V3.85A3.86,3.86,0,0,1,3.85,0ZM37.11,1.33H3.85A2.53,2.53,0,0,0,1.33,3.85V20.6a2.54,2.54,0,0,0,2.52,2.53H37.11a2.54,2.54,0,0,0,2.52-2.53V3.85a2.53,2.53,0,0,0-2.52-2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.79,16l1.26-7.42h2L18.81,16Zm9.36-7.24a5.24,5.24,0,0,0-1.81-.31c-2,0-3.41,1-3.42,2.45,0,1.06,1,1.66,1.77,2s1,.6,1,.92c0,.5-.63.73-1.21.73a4.24,4.24,0,0,1-1.91-.39L20.36,14l-.28,1.66a6.3,6.3,0,0,0,2.25.4c2.13,0,3.51-1,3.52-2.54,0-.84-.53-1.49-1.69-2-.71-.35-1.14-.58-1.14-.92s.37-.64,1.16-.64a3.72,3.72,0,0,1,1.51.28l.18.09.28-1.61Zm5.19-.18H29.77a1,1,0,0,0-1.06.62l-3,6.8h2.12l.43-1.12h2.59L31.1,16H33L31.34,8.53Zm-2.5,4.79.81-2.08.27-.71.13.64s.39,1.77.47,2.15ZM15.09,8.53l-2,5.06-.21-1a5.81,5.81,0,0,0-2.8-3.11l1.81,6.49h2.14l3.18-7.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.27,8.53H8l0,.15a6.7,6.7,0,0,1,4.91,3.88l-.71-3.41A.84.84,0,0,0,11.27,8.53Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.064a49395d46d16372bc2593acb79536.svg";
export { ForwardRef as ReactComponent };